import Kfit from 'integrations/Kfit';

export default params => Kfit.post(`/v5/reports`, params).then(res => res);
